import { LegalPage } from "./LegalPage";
import { PRIVACY_DOC } from "./legalDocs";

/** Aviso de privacidad (docs/legal/aviso_privacidad.md): público, con el candado de marcadores {{ }}. */
export const PrivacyNoticePage = () => <LegalPage doc={PRIVACY_DOC} />;

PrivacyNoticePage.path = PRIVACY_DOC.path;
